/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to create a bank account from an uploaded RIB document
 * @export
 * @interface CreateBankAccountFromRibCommand
 */
export interface CreateBankAccountFromRibCommand {
    /**
     * ID of the person who owns the bank account
     * @type {string}
     * @memberof CreateBankAccountFromRibCommand
     */
    personId: string;
    /**
     * IBAN validated/modified by the user (extracted from RIB)
     * @type {string}
     * @memberof CreateBankAccountFromRibCommand
     */
    iban: string;
    /**
     * SWIFT/BIC code of the bank (optional, extracted from RIB)
     * @type {string}
     * @memberof CreateBankAccountFromRibCommand
     */
    bic?: string;
    /**
     * Label for the bank account
     * @type {string}
     * @memberof CreateBankAccountFromRibCommand
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBankAccountFromRibCommand
     */
    storedFileId: string;
}

/**
 * Check if a given object implements the CreateBankAccountFromRibCommand interface.
 */
export function instanceOfCreateBankAccountFromRibCommand(value: object): value is CreateBankAccountFromRibCommand {
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    return true;
}

export function CreateBankAccountFromRibCommandFromJSON(json: any): CreateBankAccountFromRibCommand {
    return CreateBankAccountFromRibCommandFromJSONTyped(json, false);
}

export function CreateBankAccountFromRibCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBankAccountFromRibCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'],
        'iban': json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'label': json['label'],
        'storedFileId': json['storedFileId'],
    };
}

export function CreateBankAccountFromRibCommandToJSON(json: any): CreateBankAccountFromRibCommand {
    return CreateBankAccountFromRibCommandToJSONTyped(json, false);
}

export function CreateBankAccountFromRibCommandToJSONTyped(value?: CreateBankAccountFromRibCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'iban': value['iban'],
        'bic': value['bic'],
        'label': value['label'],
        'storedFileId': value['storedFileId'],
    };
}

